module.exports = __webpack_public_path__ + "static/media/PriceDiff.0071b7f3.png";